import { Dialog, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { tokens } from "../../global/theme/tokens";
import CardGrid from "../../components/cards/layout/CardGrid";
import SkeletonCard from "../../components/cards/SkeletonCard";
import { useState } from "react";
import { API_DELETE, DBRequest, useConfig } from "../../api/api";
import TextCard from "../../components/cards/TextCard";
import SpeedDialMenu from "../../components/menu/SpeedDialMenu";
import Feedback from "../../components/special/Feedback";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import MoneyCard from "../../components/cards/MoneyCard";
import PercentCard from "../../components/cards/PercentCard";
import MoneyLabel from "../../components/label/MoneyLabel";
import NoPhotographyIcon from "@mui/icons-material/NoPhotography";
import ExoAvatar from "../../components/exo/ExoAvatar";
import NewProduct from "../../components/new/NewProduct";
import useFetch from "../../api/useFetch";
import ExoDialog from "../../components/exo/ExoDialog";

const ExtendProduct = ({ row, onUpdate, onDelete, skr03 }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();
  const config = useConfig();

  const { apiData, setApiData } = useFetch(`products/${row.id}`);

  const [open, setOpen] = useState(false);
  const [startData, setStartData] = useState(null);

  // menu
  const actions = [
    {
      icon: <ModeEditIcon />,
      name: t("Edit"),
      onClick: handleEdit,
    },
    {
      icon: <ContentCopyIcon />,
      name: t("Copy"),
      onClick: handleCopy,
    },
    { icon: <DeleteOutlineIcon />, name: t("Delete"), onClick: handleDelete },
  ];

  function handleEdit() {
    setStartData(apiData.data);
    setOpen(true);
  }

  function handleCopy() {
    const dataCopied = {};
    dataCopied.name = apiData.data.name;
    dataCopied.price = apiData.data.price;
    dataCopied.taxRate = apiData.data.taxRate;
    dataCopied.unit = apiData.data.unit;
    dataCopied.image = apiData.data.image;
    dataCopied.purchasePrice = apiData.data.purchasePrice;
    dataCopied.description = apiData.data.description;
    var categorieIds = [];
    apiData.data.productCategories.forEach((category) => {
      categorieIds.push(category.id);
    });
    dataCopied.productCategoryIds = categorieIds;
    setStartData(dataCopied);
    setOpen(true);
  }

  function handleUpdate(data) {
    setOpen(false);
    setApiData({ ...apiData, data });
    onUpdate(data);
  }
  // delete
  function handleDelete() {
    DBRequest({
      config,
      path: `products/${row.id}`,
      method: API_DELETE,
      onFeedback: handleAlertOpen,
    });
    onDelete();
  }

  // feedback
  const [alertState, setAlertState] = useState({
    alertOpen: false,
    alertType: "info",
    alertText: "test",
  });
  function handleAlertOpen(text, type) {
    setAlertState({ alertOpen: true, alertText: text, alertType: type });
  }

  return !apiData ? (
    <ProductSkeleton />
  ) : (
    <CardGrid>
      <TextCard
        text={
          <>
            <ExoAvatar
              picture={apiData.data.image && apiData.data.image.temporaryUrl}
              icon={<NoPhotographyIcon />}
            />

            {apiData.data.name}
          </>
        }
        span={99}
      />
      <MoneyCard
        amount={apiData.data.purchasePrice}
        title={t("Purchase Price")}
      />
      <MoneyCard
        amount={apiData.data.price}
        title={`${t("Selling Price")} ${t("Netto")}`}
      />
      <MoneyCard
        amount={apiData.data.price * (apiData.data.taxRate / 100 + 1)}
        title={`${t("Selling Price")} ${t("Brutto")}`}
      />
      <PercentCard
        percent={
          (apiData.data.price - apiData.data.purchasePrice) / apiData.data.price
        }
        amount={
          <MoneyLabel money={apiData.data.price - apiData.data.purchasePrice} />
        }
        label={t("Profit")}
      />
      <SpeedDialMenu actions={actions} />
      <Feedback setState={setAlertState} state={alertState} />
      <ExoDialog open={open} limitWidth>
        <NewProduct
          onClose={() => setOpen(false)}
          onCreate={handleUpdate}
          startData={startData}
          fullWidth
        />
      </ExoDialog>
    </CardGrid>
  );
};
const ProductSkeleton = () => {
  return (
    <CardGrid>
      <SkeletonCard height={52} span={4} />
      <SkeletonCard height={191} />
      <SkeletonCard height={191} />
      <SkeletonCard height={191} />
      <SkeletonCard height={191} />
      <SkeletonCard height={156} span={4} />
    </CardGrid>
  );
};

export default ExtendProduct;
